function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M35,8H65.437l5.784,5.922V51.658H35Zm9.641,28.922h16.94v2.2H44.641Zm0-16.389h16.94v2.341H44.641Zm0,4.132h16.94v2.2H44.641Zm0,4.132h16.94V31H44.641Zm0,3.994h16.94v2.2H44.641Zm20.8-21.9,3.03,3.03h-3.03Zm3.856,5.1H63.371V10.066H37.066V49.592H69.293Z",
  transform: "translate(-35 -8)",
  fill: "#40444a",
  fillRule: "evenodd"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "noun_Paper_2964417",
    width: 36.221,
    height: 43.658,
    viewBox: "0 0 36.221 43.658"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/paper.0a844b3f.svg";
export { SvgComponent as ReactComponent };